<template>
  <div class="main-page-block">
    <h1>
      Адреса общежитий
    </h1>

    <div class="row">
      <div class="dorms-item">
        <img alt="" class="img-responsive" src="https://storage.tusur.ru/files/137308/330-220/dormitory-1.png" />
        <div class="location-box">
          <h2>
            Общежитие № 1
          </h2>
          <span class="faculties">Магистры, аспиранты</span>

          <p class="dorms-item__adress">
            <img alt="" src="https://storage.tusur.ru/files/158094/address.svg" /> <a class="target info" data-x="56.4515" data-y="84.9770" href="#">ул. 19-й Гвардейской Дивизии, 9а</a>
          </p>

          <p>
            <img alt="" src="https://storage.tusur.ru/files/158097/telephone.svg" /> (3822) 90-01-04
          </p>

          <p>
            <strong>Заведующий общежитием:</strong><br />
            Ольга Викторовна Зайцева
          </p>
        </div>
      </div>

      <div class="dorms-item">
        <img alt="" class="img-responsive" src="https://storage.tusur.ru/files/137307/330-220/dormitory-3.png" />
        <div class="location-box">
          <h2>
            Общежитие № 3
          </h2>

          <p class="dorms-item__adress">
            <img alt="" src="https://storage.tusur.ru/files/158094/address.svg" /> <a class="target info" data-x="56.4667" data-y="84.9774" href="#">пр-т Кирова, 56а</a>
          </p>

          <p>
            <img alt="" src="https://storage.tusur.ru/files/158097/telephone.svg" /> (3822) 55-54-66, (3822) 55-75-47
          </p>

          <p>
            <strong>Заведующий общежитием:</strong><br />
            Дмитрий Владимирович Батрак
          </p>
        </div>
      </div>

      <div class="dorms-item">
        <img alt="" class="img-responsive" src="https://storage.tusur.ru/files/137306/330-220/dormitory-4.png" />
        <div class="location-box">
          <h2>
            Общежитие № 4
          </h2>

          <p class="dorms-item__adress">
            <img alt="" src="https://storage.tusur.ru/files/158094/address.svg" /> <a class="target info" data-x="56.4525" data-y="84.9736" href="#">ул. Ф. Лыткина, 10</a>
          </p>

          <p>
            <img alt="" src="https://storage.tusur.ru/files/158097/telephone.svg" /> (3822) 41-39-93
          </p>

          <p>
            <strong>Заведующий общежитием:</strong><br />
            Олег Анатольевич Кузьменко
          </p>
        </div>
      </div>

      <div class="dorms-item">
        <img alt="" class="img-responsive" src="https://storage.tusur.ru/files/137305/330-220/dormitory-5.png" />
        <div class="location-box">
          <h2>
            Общежитие № 5
          </h2>

          <p class="dorms-item__adress">
            <img alt="" src="https://storage.tusur.ru/files/158094/address.svg" /> <a class="target info" data-x="56.4516" data-y="84.9749" href="#">ул. Ф. Лыткина, 18</a>
          </p>

          <p>
            <img alt="" src="https://storage.tusur.ru/files/158097/telephone.svg" /> (3822) 41-25-68, (3822) 41-26-61
          </p>

          <p>
            <strong>Заведующий общежитием:</strong><br />
            Евгений Анатольевич Юшкевич
          </p>
        </div>
      </div>

      <div class="dorms-item">
        <img alt="" class="img-responsive" src="https://storage.tusur.ru/files/137304/330-220/dormitory-6.png" />
        <div class="location-box">
          <h2>
            Общежитие № 6
          </h2>

          <p class="dorms-item__adress">
            <img alt="" src="https://storage.tusur.ru/files/158094/address.svg" /> <a class="target info" data-x="56.4526" data-y="84.9749" href="#">ул. Ф. Лыткина, 8</a>
          </p>

          <p>
            <img alt="" src="https://storage.tusur.ru/files/158097/telephone.svg" /> (3822) 41-29-01
          </p>

          <p>
            <strong>Заведующий общежитием:</strong><br />
            Дмитрий Владимирович Батрак
          </p>
        </div>
      </div>
    </div>
    <div class="" style="background-image: image_url(/assets/placemark.svg); height: 50px; width: 35px;"></div>
    <div id="js-contacts-map" class="contacts-map">
      <div class="info-box">
        <ul class="ul-rhombus">
          <li>
            <a class="target not-scroll" data-x="56.4515" data-y="84.9770" href="#">Общежитие № 1</a>
          </li>
          <li>
            <a class="target not-scroll" data-x="56.4667" data-y="84.9774" href="#">Общежитие № 3</a>
          </li>
          <li>
            <a class="target not-scroll" data-x="56.4525" data-y="84.9736" href="#">Общежитие № 4</a>
          </li>
          <li>
            <a class="target not-scroll" data-x="56.4516" data-y="84.9749" href="#">Общежитие № 5</a>
          </li>
          <li>
            <a class="target not-scroll" data-x="56.4526" data-y="84.9749" href="#">Общежитие № 6</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
export default {
  data: () => {
    return {}
  },
  created() {
    this.ymap();
  },
  methods: {
    ymap() {
      $.getScript('//api-maps.yandex.ru/2.1/?lang=ru_RU', function() {
        ymaps.ready(function() {

          // Disable links to places in xs resolution and hide map
          if ($("#js-contacts-map:visible").length === 0) {
              $("a.target.info").click(function(e) {
                  e.preventDefault();
              });
              return;
          }

          // Initialization yandex map
          let map = new ymaps.Map('js-contacts-map', {
              center: [parseFloat($('a.target.info:first').attr('data-x')), parseFloat($('a.target.info:first').attr('data-y'))],
              //center: [55.76, 37.64]
              zoom: 14,
              behaviors: ['drag', 'scrollZoom'],
              maxZoom: 23,
              controls: ['fullscreenControl'],
              minZoom: 3,
              maxAnimationZoomDifference: 5
          });

        // enterFullscreen

          // set default ballon
          let open_balloon = function(x, y, content) {
            map.balloon.open([x, y], {
              content: content
            }, 
            {
              closeButton: true,
              autoPan: false,
              left: 0
            });
          };
          
          // set placemark
          let set_placemark = function(x, y, contentBalloon) {
            let placemark = new ymaps.Placemark([x, y], {
              balloonContent: contentBalloon
            }, 
            {
              iconLayout: 'default#image',
              iconImageSize: [35, 50],
              iconImageOffset: [-17, -50],
              iconImageHref: 'https://storage.tusur.ru/files/167408/placemark.svg'
            });
            map.geoObjects.add(placemark);
          };

          // function for display all placemarks on map
          let placemarks_data = {};
          
          let display_all_placemarks = function() {
            $("a.target.info").each(function(index, target) {
              let x = $(target).attr("data-x");
              let y = $(target).attr("data-y");
              let balloonContent = "<div class='col-xs-12 location-box map-box'> " + $(target).closest('div.location-box').html() + "</div>";
              set_placemark(x, y, balloonContent);
              placemarks_data[x + ", " + y] = balloonContent;
            });
            return placemarks_data;
          };
          
          // on click to target, move to eny place
          $(".target").click(function(e) {
            e.preventDefault();
            window.scrollTo({
              top: document.querySelector('.contacts-map').offsetTop - 60,
              behavior: 'smooth'
            });

            let x = $(this).attr("data-x");
            let y = $(this).attr("data-y");

            map.panTo([parseFloat(x), parseFloat(y)], {
              safe: false,
              flying: false,
              duration: 1000,
              delay: 1000
            }).then(function() {
              let content = placemarks_data[x + ", " + y];
              open_balloon(x, y, content);
            });
          });

          // open default balloon
          display_all_placemarks();

          let def_x = $("a.main-corp").attr("data-x");
          let def_y = $("a.main-corp").attr("data-y");
          let def_content = placemarks_data[def_x + ", " + def_y];

          open_balloon(def_x, def_y, def_content);

        });
      });
    }
  }
};
</script>